import { LuCalendarDays } from "react-icons/lu";
import { RxDividerVertical } from "react-icons/rx";
import {
  FilterContainer,
  CalendarTextHolder,
} from "../../pages/Dashboard/Dashboard.styles";
import {
  CalendarText,
  CalendarLinkText,
} from "../DashBoardComponents/EmptyDashBoard/EmptyDashboard.styles";
import { colors } from "../../theme/color";

const CalenderComponent = () => {
  return (
    <FilterContainer>
      <LuCalendarDays
        color={colors.ButtonBackgroundColors.primaryDefaultButton}
        size={"20px"}
      />
      <CalendarTextHolder>
        <CalendarText>From: </CalendarText>
        <CalendarLinkText>Start Date</CalendarLinkText>
      </CalendarTextHolder>
      <RxDividerVertical color={colors.LIGHT_GRAY} />
      <CalendarTextHolder>
        <CalendarText>To: </CalendarText>
        <CalendarLinkText> End Date</CalendarLinkText>
      </CalendarTextHolder>
    </FilterContainer>
  );
};

export default CalenderComponent;
